
const base_url = "https://alphafold.ebi.ac.uk"; 
const pdbe_base_url = "https://www.ebi.ac.uk/pdbe"; 

export const environment = {
  localEnv: "prod",
  production: true,
  baseUrl: base_url,
  verifyUrl: base_url + "/api/access/verify",
  uniprotApiUrl: "https://www.ebi.ac.uk/proteins/api/proteins/",
  uniprotEntryUrl: "https://www.uniprot.org/uniprot/",
  entryApiUrl: base_url + '/api/prediction/',
  complexUrl: base_url + '/api/complex/',
  providerApiUrl: base_url + '/api/providers/',
  pdbeApiUrl: pdbe_base_url + '/api/mappings/best_structures/',
  pdbeKbEntryUrl: pdbe_base_url + '/pdbe-kb/proteins/',
  googleAnalyticsTag: "G-RPJQZYPKWN",
  recaptchaVerifyKey: '6LdammEsAAAAACbYduTTCTQJGRHlu1y3IPl8w0We',
  searchApiUrl: base_url + '/api/search',
  latestApiUrl: base_url + '/api/latest',
  downloadApiUrl: base_url + '/api/download',
  suggestApiUrl: base_url + '/api/suggest',
  apiKey: undefined, //"AIzaSyCeurAJz7ZGjPQUtEaerUkBZ3TaBkXrY94",
  swaggerApiUrl: base_url + '/api/openapi.json',
  clusterApiUrl: base_url + '/api/cluster/members/',
  structureSearchApiUrl: base_url + '/api/structure/search/',
  pdbeBaseApiUrl: pdbe_base_url,
  llmAnnotationsApiUrl: pdbe_base_url + '/api/v2/uniprot/llm_annotations/summary/',
  domainsApiUrl: base_url + '/api/domains/',
  complexIntactApiUrl: 'https://www.ebi.ac.uk/intact/complex-ws/',
  complexPortalUrl: 'https://www.ebi.ac.uk/complexportal/complex/'
};